module.exports = __webpack_public_path__ + "static/img/topbg.9bab3b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/topbg.jpg
// module id = xBuT
// module chunks = 1